(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rover-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function setText(root, part, value) {
      var node = root.querySelector('[data-bq-rcd="' + part + '"]');
      if (node) node.textContent = value;
    }

    function setupCountdown(timer) {
      if (!timer || timer.dataset.bqRoverCountdownReady === 'true') return;

      var target = new Date(timer.getAttribute('data-target'));
      var completeLabel = timer.getAttribute('data-complete-label') || '';

      timer.dataset.bqRoverCountdownReady = 'true';

      if (Number.isNaN(target.getTime())) {
        timer.setAttribute('aria-label', completeLabel);
        timer.classList.add('is-complete');
        return;
      }

      function tick() {
        var diff = Math.max(0, target.getTime() - Date.now());
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        setText(timer, 'days', pad(days));
        setText(timer, 'hours', pad(hours));
        setText(timer, 'minutes', pad(minutes));
        setText(timer, 'seconds', pad(seconds));

        if (diff <= 0) {
          timer.classList.add('is-complete');
          timer.setAttribute('aria-label', completeLabel);
          return;
        }

        timer.classList.remove('is-complete');
        timer.setAttribute('aria-label', days + ' days ' + hours + ' hours ' + minutes + ' minutes ' + seconds + ' seconds until Rover launch');
      }

      tick();
      window.setInterval(tick, 1000);
    }

    function setupScrollBehavior(observer) {
      if (!observer || observer.dataset.bqRoverScrollReady === 'true') return;

      var lastScrollY = Math.max(0, window.scrollY);
      var frame = null;
      var isCollapsed = false;
      var section = observer.closest('.shopify-section');
      var isPurchaseBar = !!observer.querySelector('[data-bq-rover-purchase-bar]');

      function setCollapsed(next) {
        if (isCollapsed === next) return;

        isCollapsed = next;
        observer.classList.toggle('is-collapsed', next);
        if (section) section.classList.toggle('is-collapsed', next);
        observer.toggleAttribute('inert', next);
      }

      function applyScrollState() {
        frame = null;

        var currentScrollY = Math.max(0, window.scrollY);

        if (isPurchaseBar) {
          var hero = document.querySelector('.rover-hero');
          var heroBottom = hero ? hero.getBoundingClientRect().bottom : 0;
          setCollapsed(heroBottom > 8);
          lastScrollY = currentScrollY;
          return;
        }

        if (currentScrollY <= 4) {
          setCollapsed(false);
        } else if (currentScrollY > 12 && currentScrollY > lastScrollY + 2) {
          setCollapsed(true);
        }

        lastScrollY = currentScrollY;
      }

      function onScroll() {
        if (frame !== null) return;

        frame = window.requestAnimationFrame(applyScrollState);
      }

      function onSectionUnload(event) {
        if (event.target !== section) return;

        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        if (frame !== null) window.cancelAnimationFrame(frame);
      }

      observer.dataset.bqRoverScrollReady = 'true';
      if (isPurchaseBar) {
        setCollapsed(true);
        window.requestAnimationFrame(applyScrollState);
      } else {
        observer.classList.remove('is-collapsed');
        if (section) section.classList.remove('is-collapsed');
        observer.removeAttribute('inert');
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }

    function setupAll(root) {
      (root || document).querySelectorAll('[data-bq-rover-countdown]').forEach(function (timer) {
        setupCountdown(timer);
        setupScrollBehavior(timer.closest('.bq-rover-countdown-banner__observer'));
      });

      (root || document).querySelectorAll('[data-bq-rover-purchase-bar], [data-bq-rover-home-bar]').forEach(function (bar) {
        setupScrollBehavior(bar.closest('.bq-rover-countdown-banner__observer'));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setupAll(document); });
    } else {
      setupAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setupAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
